import XAPPService from "app/Core/services/XAPPService";
import _ from "lodash";

export const GET_INTEGRACOES = "[MARKETPLACE APP] GET INTEGRACOES";
export const GET_INTEGRACAO = "[MARKETPLACE APP] GET INTEGRACAO";
export const MARKETPLACE_ERROR = "[MARKETPLACE APP] MARKETPLACE ERROR";
export const MARKETPLACE_INFO = "[MARKETPLACE APP] MARKETPLACE INFO";
export const MARKETPLACE_WARNING = "[MARKETPLACE APP] MARKETPLACE WARNING";
export const MARKETPLACE_RESPONSE_INTEGRACAO = "[MARKETPLACE APP] MARKETPLACE DATA INTEGRACAO";

const GetState = [
    "idpessoa",
    "idpessoaformulario",
    "tipo",
    "setup",
    "idintegracao",
];

const AddState = [
    "idpessoa",
    "idpessoaformulario",
    "tipo",
    "setup",
    "idintegracao",
];

export function getListaIntegracoes() {
    return (dispatch, getState) => {

        XAPPService.XappGetTemplateAction("integracao", getState().auth.user.data.settings.pathintegracao)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_INTEGRACOES,
                        payload: response,
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: MARKETPLACE_ERROR,
                    payload: error
                });
            });
    };
}

export function save(_AValue, _AParams, _AAction, _ACallback = null) {
    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "idintegracao", "Operador": "=", "Valor": _AValue.idintegracao }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "integracao", _AAction, _AValue, "idintegracao", AConditionsAND, AConditionsOR, 1, AddState);

        XAPPService.XappDoAction(AActions, _AParams)
            .then((response) => {
                if (response.warning) {
                    dispatch({
                        type: MARKETPLACE_WARNING,
                        payload: response.warning
                    });
                }
                else if (response.info) {
                    dispatch({
                        type: MARKETPLACE_INFO,
                        payload: response.info,
                        id: response.ultimoidinserido
                    });
                }

                if (!_.isNull(_ACallback)) {
                    _ACallback();
                }
            }

            ).catch(error => {
                return dispatch({
                    type: MARKETPLACE_ERROR,
                    payload: error
                });
            });
    };
}

export function get(_AParams, _ATipo) {

    return (dispatch) => {

        var AConditionsAND = [{ Campo: "integracao.tipo", Operador: "=", Valor: _ATipo }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "integracao", AActions, "spvwintegracao", GetState, "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_INTEGRACAO,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data[0] : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: MARKETPLACE_ERROR,
                    payload: error
                });
            });
    };
}

export function clearReducer() {
    return {
        type: GET_INTEGRACAO,
        payload: null
    };
}

export function integracao(_AAction, _AValue, _AParams, _ATipo) {
    return (dispatch) => {

        var AActions = [];

        AActions = XAPPService.XappIntegracaoActionFactory(_AParams.empresa, AActions, "", _AAction, _AValue);

        XAPPService.XappIntegracaoAction(AActions, _AParams, _ATipo)
            .then((response) => {
                if (response.data) {
                    Promise.all([
                        dispatch({
                            type: MARKETPLACE_RESPONSE_INTEGRACAO,
                            payload: response.data
                        })
                    ]);//.then(() => dispatch(listPagarReceber(_AParams, _AFilter)))
                }
            })
            .catch(error => {
                return dispatch({
                    type: MARKETPLACE_ERROR,
                    payload: error
                });
            });
    };
}